export default __webpack_public_path__ + "static/latitude-asx-2a908ab598516bb2dd897730a64b08ee.jpg";